import React, { memo } from 'react'
import { Typography } from '@mui/material'

export interface AlertItemProps {
    title: string,
    value: any
}

function OrderBookItem({ title, value }: AlertItemProps) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                flexDirection: 'row',
                gap: 8,
                minWidth: 0,
            }}
        >
            <Typography
                style={{ fontSize: '13px', padding: '2px', whiteSpace: 'nowrap', flexShrink: 0 }}
                sx={{ color: (theme) => theme.palette.text.disabled }}
            >
                {title}
            </Typography>
            <Typography
                className="font-feature-num"
                style={{
                    fontSize: '13px',
                    lineHeight: 1.5,
                    padding: '2px',
                    whiteSpace: 'nowrap',
                    textAlign: 'right',
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {value}
            </Typography>
        </div>
    )
}

export default memo(OrderBookItem)
